import { useCallback, useEffect, useState } from 'react';
import { MAX_COVER_CROP_FRACTION, coverCropFraction, fitCover } from '../utils/coverLayout';

export default function usePlayerCoverLayout(source) {
  const [album, setAlbum] = useState(null);
  const [layout, setLayout] = useState(null);
  const measure = useCallback(() => {
    const image = album?.querySelector('img');
    if (!image?.naturalWidth || !image.naturalHeight || !album.clientWidth || !album.clientHeight) {
      setLayout(null);
      return;
    }
    const width = album.clientWidth;
    // Ignore the decorative safe-area extension when selecting the cover mode,
    // so switching to contained mode cannot flip the crop decision back again.
    const safeAreaExtension = parseFloat(getComputedStyle(album).getPropertyValue('--player-safe-area-extension')) || 0;
    const height = Math.max(1, album.clientHeight - safeAreaExtension);
    const contained = coverCropFraction(image.naturalWidth, image.naturalHeight, width, height) >= MAX_COVER_CROP_FRACTION;
    const next = contained ? fitCover(image.naturalWidth, image.naturalHeight, Math.max(1, width - 32), Math.max(1, height - 32)) : null;
    setLayout(previous => previous?.width === next?.width && previous?.height === next?.height ? previous : next);
  }, [album]);
  useEffect(() => {
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (album) observer?.observe(album);
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, [album, source, measure]);
  return { albumRef: setAlbum, onLoad: measure, layout };
}
